/* The Bakery: treats ride the conveyor (gliding every display frame, with a stop-motion bump on the 12 fps clock); scrolling
   speeds the belt up, hovering or focusing stops it, the counter bell stops it too and makes every treat hop. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('bakery', function (sec) {
    var belt = sec.querySelector('[data-belt]'), track = sec.querySelector('[data-track]'), rail = sec.querySelector('[data-rail]');
    var bell = sec.querySelector('[data-bell]');
    var treats = Array.prototype.slice.call(sec.querySelectorAll('[data-treat-body]'));
    var x = 0, half = 1, hover = false, hold = false, visible = false;
    function measure() { half = Math.max(1, track.scrollWidth / 2); }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
    else visible = true;
    belt.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    belt.addEventListener('pointerleave', function () { hover = false; });
    belt.addEventListener('focusin', function () { hover = true; });
    belt.addEventListener('focusout', function () { hover = false; });
    /* a finger swipe on the belt nudges it along */
    var sx = null;
    belt.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; hold = true; }, { passive: true });
    belt.addEventListener('touchmove', function (e) { if (sx === null) return; var nx = e.touches[0].clientX; x += nx - sx; sx = nx; wrap(); paint(); }, { passive: true });
    belt.addEventListener('touchend', function () { sx = null; setTimeout(function () { hold = false; }, 1600); });

    function wrap() { if (-x >= half) x += half; if (x > 0) x -= half; }
    function paint() { track.style.transform = 'translateX(' + x.toFixed(1) + 'px)'; rail.style.setProperty('--belt', (((x % 61) + 61) % 61).toFixed(1) + 'px'); }
    if (!WH.reduce) {
      WH.onTick(function (dt) {
        if (!visible || hover || hold) return;
        x -= (96 + Math.min(432, Math.abs(WH.scroll.v) * 8.4)) * dt;
        wrap(); paint();
      });
      WH.onFrame(function (f) {
        if (!visible || hover || hold) return;
        /* a little conveyor bump every few frames */
        if (f % 6 === 0) treats.forEach(function (t, i) { if ((i + f / 6) % 3 < 1) t.style.transform = 'translateY(-3px) scale(1.02,.98)'; else t.style.transform = ''; });
      });
    }

    bell.addEventListener('click', function () {
      WH.sound.play('ding');
      hold = true;
      sec.classList.add('is-ding');
      if (WH.anim) {
        gsap.fromTo(bell.querySelector('svg'), { rotation: -14 }, { rotation: 0, duration: 0.6, ease: WH.sm('elastic.out(1.4,.3)', 0.6) });
        treats.forEach(function (t, i) {
          gsap.timeline({ delay: (i % 8) * 0.05 })
            .to(t, { y: -38, scaleY: 1.1, scaleX: 0.92, rotation: WH.rand(-10, 10), duration: 0.25, ease: WH.sm('power2.out', 0.25) })
            .to(t, { y: 0, scaleY: 1, scaleX: 1, rotation: 0, duration: 0.25, ease: WH.sm('power2.in', 0.25) })
            .to(t, { scaleY: 0.9, scaleX: 1.08, duration: 0.09, ease: 'none' })
            .to(t, { scaleY: 1, scaleX: 1, duration: 0.17, ease: WH.sm('power1.out', 0.17) });
        });
      }
      setTimeout(function () { hold = false; sec.classList.remove('is-ding'); }, 2600);
    });
  });
})();
